__turbopack_context__.v({
  "addButton": "quest-settings-module__3WvNaG__addButton",
  "btn": "quest-settings-module__3WvNaG__btn",
  "btnWrapper": "quest-settings-module__3WvNaG__btnWrapper",
  "buttons": "quest-settings-module__3WvNaG__buttons",
  "collectableInput": "quest-settings-module__3WvNaG__collectableInput",
  "formContainer": "quest-settings-module__3WvNaG__formContainer",
  "items": "quest-settings-module__3WvNaG__items",
  "title": "quest-settings-module__3WvNaG__title",
  "wrapperItems": "quest-settings-module__3WvNaG__wrapperItems",
});
